import { flow } from "fp-ts/lib/function";

import { Scale } from "../../lens-stats/formatters";
import { roundWithScale } from "../math";

export const formatPercentValue = (decimalPoints: 1 | 2 = 1): ((number: number | string) => string) =>
    flow(roundWithScale(Scale.h), (totalValue: number): string => totalValue.toFixed(decimalPoints) + "%");
